import { useState } from 'react';
import { addMonitoringPatientModal } from '@/stores';
import { ProtocolsModal } from './ProtocolModal';
import { QuestionnaireModal } from './QuestionnaireModal';

export function PatientNewMonitoringPage() {
  const { isOpen, onClose } = addMonitoringPatientModal();
  const [isQuestionOpen, setQuestionOpen] = useState(false);
  const [selectQuiz, setSelectQuiz] = useState(null);

  return (
    <>
      <ProtocolsModal
        isOpen={isOpen}
        onClose={onClose}
        onResponder={item => {
          setSelectQuiz(item);
          setQuestionOpen(true);
          onClose();
        }}
      />
      <QuestionnaireModal
        isOpen={isQuestionOpen}
        onClose={() => setQuestionOpen(false)}
        selectQuiz={selectQuiz}
      />
    </>
  );
}
